import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AsyncFunction } from "../../functions/AsyncFunction";

// Stateの初期状態
const initialState = {
    organizer_id: "",
    password: "",
    password2: "",
    limit_time: "",
    message: "",
};

// Sliceを生成する
const slice = createSlice({
    name: "PasswordSettingEdit",
    initialState,
    reducers: {
        PasswordSettingEdit_initialize: () => initialState,
        PasswordSettingEditSet: (state, action) => {
            const name = action.payload[0];
            const value = action.payload[1];
            state[name] = value;
        },
    },
});

//トークンからID,有効期限を取得
export const CheckPasswordUserTime = function (arg) {
    const params = {
        url: "/api/CheckPasswordUserTime",
        method: "get",
        params: { ...arg },
        type_name: "CheckPasswordUserTime",
    };
    return AsyncFunction(params);
};

//パスワード更新
export const UpdatePassword = function (arg) {
    const params = {
        url: "/api/UpdatePassword",
        method: "put",
        params: { ...arg },
        type_name: "UpdatePassword",
    };
    return AsyncFunction(params);
};

// Reducerをエクスポートする
export default slice.reducer;

// Action Creatorsをエクスポートする
export const { PasswordSettingEdit_initialize, PasswordSettingEditSet } = slice.actions;
